import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Spinner from 'components/generic/Spinner.component';
import DEPOSIT_SOURCE from 'constants/payment/depositSource.const';
import { selectBalanceSheetClientViewData } from 'selectors/balance.selectors';
import { selectBookingAppointmentStartTimeList, selectBookingIsFetching } from 'selectors/booking.selectors';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';
import logger from 'utils/logger.util';

import { getAppointmentStartTimeList } from 'booking/actions';
import ClientDepositDetails from 'settings/balance-sheet/ClientDepositDetails';
import ClientDepositSummary from 'settings/balance-sheet/ClientDepositSummary';

const L = logger('BalanceSheetLayoutDetails');

const BalanceSheetLayoutDetails = ({ clientViewData, isFetching, start, openedId, getAppointmentStartTimeList, salonId, onStart, onRefund, outstanding, clientName, appointmentStartTimeList }) => {
  const { isFetching: isClientFetching, response } = clientViewData ?? {};
  const deposits = asArray(response?.deposits_list);

  const handleRefund = useCallback(
    (ev) => {
      const parsedAmount = parseFloat(ev?.amount);
      const isValidAmount = fromAnyToBool(!Number.isNaN(ev?.amount) && parsedAmount);

      const event = {
        ...ev,
        online: ev?.source === DEPOSIT_SOURCE.online,
        parsedAmount,
        isValidAmount,
      };

      call('BalanceSheetLayoutDetails.onRefund', onRefund, event);
    },
    [onRefund],
  );

  useEffect(() => {
    if (isFetching || isClientFetching || start === openedId) return;

    const ids = [...deposits.map((d) => d.created_for_appointmentId), ...deposits.map((d) => d.used_for_appointmentIds).flat()].filter((id) => id !== null);

    L.unignore('()', 'getAppointmentStartTimeList:', getAppointmentStartTimeList(salonId, ids));
    call('BalanceSheetLayoutDetails.onStart', onStart, { openedId });
  }, [isClientFetching, getAppointmentStartTimeList, isFetching, onStart, openedId, salonId, start, deposits]);

  if (isClientFetching) return <Spinner color="white" />;
  if (!response) return null;

  return (
    <div data-bem="BalanceSheetLayoutDetails">
      <ClientDepositSummary outstanding={outstanding} />
      <ClientDepositDetails outstanding={outstanding} loading={isClientFetching} data={response} clientName={clientName} onRefund={handleRefund} appointmentStartTimeList={appointmentStartTimeList} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientViewData: selectBalanceSheetClientViewData(state),
  appointmentStartTimeList: selectBookingAppointmentStartTimeList(state),
  isFetching: selectBookingIsFetching(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAppointmentStartTimeList,
    },
    dispatch,
  );

const BalanceSheetLayoutDetailsHoc = connect(mapStateToProps, mapDispatchToProps)(BalanceSheetLayoutDetails);

export default BalanceSheetLayoutDetailsHoc;
